export default __webpack_public_path__ + "static/feature27banner-a00a3b261dfcdbb587bc572be1ccee73.svg";